export const MASTERCLASS_ONBOARDING_TARGETS = {
  explore: "explore-masterclasses-joyride",
  upcoming: "upcoming-masterclass-joyride",
  reserveMySpot: "reserve-my-spot-joyride",
  previous: "previous-masterclass-joyride",
  certificate: "masterclass-certificate-joyride",
} as const
